import useManifestPrintout from "components/scheduling/Printout/useManifestPrintout";
import {Query, useApolloClient} from "react-apollo";
import React, {useState} from "react";
import moment from "moment";
import {FINALIZED_FLIGHTS_FULL} from "components/flights/times/graphql";
import gql from "graphql-tag";
import {safeGet} from "common/util";
import {Button, message} from "antd";

export const PrintoutPercentageButton = ({...props}) => {
    const [fetchPrintout, fetching] = useManifestPrintout('FlightPercentages', 'FlightPercentages');
    const ApolloClient = useApolloClient();
    const [printoutLoading, setPrintOutLoading] = useState(false);
    const userAttr = props.cognitoUser.attributes
    const orgData = props.orgData;

    async function getFullFinalizedFlightsData(pageSizeWeeks = 2) {

        /** @type Moment */
        let startDate = props.dateRange[0];
        /** @type Moment */
        let endDate = props.dateRange[1];

        let duration = moment.duration(endDate.diff(startDate));
        let noWeeks = Math.ceil(duration.as('weeks'));

        setPrintOutLoading(true);

        function getDataPage(subStartDate, subEndDate) {
            return {
                execute: () => {
                    return ApolloClient.query({
                        variables: {
                            tpID: props.orgData.transporter._id,
                            customerID: props.orgData.customer._id,
                            startDate: subStartDate.format('YYYY-MM-DD'),
                            endDate: subEndDate.format('YYYY-MM-DD'),
                            departureID: props.departureID && props.departureID.key
                        },
                        query: FINALIZED_FLIGHTS_FULL,
                        fetchPolicy: 'no-cache'
                    })
                }
            }
        }

        // Fetch each page of data two pages at a time using two queues.
        const pageQueue = [];
        const results = [];
        let executeQueue = [];

        for (let pageNum = 0; pageNum <= noWeeks; pageNum += pageSizeWeeks) {
            let subStartDate = moment(startDate).add(pageNum, 'weeks');
            if (pageNum !== 0) {
                subStartDate.add(1, 'day'); // Prevent overlapping between pages
            }
            let subEndDateCandidate = moment(startDate)
                .add(pageNum + pageSizeWeeks, 'weeks');

            let subEndDate = subEndDateCandidate.isAfter(endDate, 'date') ? endDate : subEndDateCandidate;
            if (subStartDate.isAfter(subEndDate, 'date')) {
                continue;
            }
            pageQueue.push(getDataPage(subStartDate, subEndDate));
        }

        while (pageQueue.length) {
            executeQueue.push(pageQueue.pop());
            if (executeQueue.length >= 3 || (!pageQueue.length && executeQueue.length)) {
                results.push(...await Promise.all(executeQueue.map(p => p.execute())));
                executeQueue = [];
            }
        }

        let compiledResults = [];
        results.forEach((queryResult, idx) => {
            if (queryResult.error) {
                console.error('Failed to fetch page ' + (idx + 1) + ' of results!', queryResult.error)
                return;
            }
            let data = queryResult.data.getFinalizedFlights.docs;
            compiledResults = compiledResults.concat(data);
        })
        return compiledResults;
    }

    return (
        <Query
            query={gql`
                query GetCustomerManifestPrintout($id: ID!){
                    getCustomer(_id: $id){
                        _id
                        name
                        manifestPrintout {
                            type
                            layouts {
                                name
                                logo
                            }
                        }
                    }
                }
            `}
            variables={{id: orgData.customer._id}}
        >
            {({data}) => {
                const manifestPrintouts = safeGet(['getCustomer', 'manifestPrintout'], data) || [];
                const flightManifest = manifestPrintouts.find((m) => m.type === 'Flight');
                const hessLayout = flightManifest && flightManifest.layouts.find((l) => l.name === 'Hess');
                const logoURL = hessLayout && hessLayout.logo;
                const handleClick = async () => {
                    try {
                        var flights = await getFullFinalizedFlightsData(1);
                    } catch (err) {
                        setPrintOutLoading(false);
                        console.error(err);
                        message.error('One or more pages of data failed to be fetched. You may need to narrow your date range.', 6)
                        return;
                    }
                    const body = {
                        issuedBy: `${userAttr.given_name} ${userAttr.family_name}`,
                        orgName: orgData.customer.name,
                        logoURL: logoURL,
                        flights: flights,
                        layoutName: props.dateRange[0].format("MMMM DD, YYYY") === props.dateRange[1].format("MMMM DD, YYYY") ?
                            `${orgData.customer.name} Flight Usage for ` + props.dateRange[0].format("MMMM DD, YYYY") :
                            `${orgData.customer.name} Flight Usage for ` + props.dateRange[0].format("MMMM DD, YYYY") + " - " + props.dateRange[1].format("MMMM DD, YYYY")
                    }
                    fetchPrintout(body, true, `${orgData.customer.name} Flight Usages ${props.dateRange[0].format('MMM DD, YYYY')} - ${props.dateRange[1].format('MMM DD, YYYY')}.xlsx`)
                        .then(() => setPrintOutLoading(false))
                        .catch((err) => {
                            setPrintOutLoading(false);
                            message.error('Failed to download printout', 3).then(() => {
                                message.error(err.message, 5);
                            }, null)
                        })
                }
                return (
                    <Button {...props} onClick={handleClick} loading={fetching || printoutLoading}>Download Usages
                        Printout</Button>
                )
            }}
        </Query>
    )
}